import { Chip, Tooltip } from "@mui/joy";
import { Box } from "@mui/system";
import { Timer } from "../entities";
import { KronosTimerString } from "./kronosTimerString";

/**
 *
 * @returns {ReactElement} KronosTimerChip page
 */
export function KronosTimerChip({
  timer,
  onClick,
  tooltip,
  size,
  helmet,
}: KronosTimerChipType) {
  return (
    <Tooltip title={tooltip} arrow size="sm">
      <Chip
        size={"md"}
        color={timer ? "primary" : "neutral"}
        variant={timer ? "solid" : "outlined"}
        onClick={onClick}
        startDecorator={<i className="fa-solid fa-timer"></i>}
        endDecorator={
          <i className="fa-solid fa-arrow-up-right-from-square"></i>
        }
      >
        <Box sx={{ minWidth: 80, textAlign: "center" }}>
          <KronosTimerString helmet={helmet} startDateUTC={timer?.start()} />
        </Box>
      </Chip>
    </Tooltip>
  );
}

type KronosTimerChipType = {
  timer?: Timer;
  onClick?: () => void;
  tooltip?: string;
  helmet?: boolean;
  size?: "sm" | "md" | "lg" | undefined;
};
